import React, { useState } from "react";

/**
 * @typedef AdminPrivilegeContextType
 * @property {boolean=} virtualTagEnabled
 * @property {React.Dispatch<boolean>} setVirtualTagEnabled
 */

/** @type {import("react").Context<AdminPrivilegeContextType>} */
export const AdminSettingContext = React.createContext();

export const useAdminSettingContext = () => {
  const [virtualTagEnabled, setVirtualTagEnabled] = useState(false);
  
  return {
    virtualTagEnabled,
    setVirtualTagEnabled,
  
  };
};
